export default __webpack_public_path__ + "static/media/freshveg.ab0bbfbe.png";